'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/videoComponent'));
    processInclude(require('../components/clpServicesSlick'));
    processInclude(require('./components/staticContactUs'));
    processInclude(require('./components/staticPageTabSection'));
    processInclude(require('./components/jobListingLayout'));
    processInclude(require('./components/careerJobForm'));
    processInclude(require('./components/blogTilesLayout'));
    processInclude(require('./components/customVideoComponent'));
    processInclude(require('./components/pickupservice'));
    processInclude(require('./components/astralService'));
    processInclude(require('./components/earpiercing'));
    processInclude(require('./components/franchiseFileUpload'));
    processInclude(require('./components/vintagecar'));
    processInclude(require('./components/jewelryService'));
    processInclude(require('./components/loyaltyEnrolmentForm'));
    processInclude(require('./components/infoBasedPlay'));

    if ($('.tab-news-magazine').hasClass('d-none')) {
        $('.tab-news-magazine').removeClass('d-none');
    }

    /**
     * Displays the colored version of the board member image for the provided card element.
     *
     * @param {JQuery} card - Card container whose imagery should be toggled to the color variant.
     */
    function showColor(card) {
        card.find('.board-person-black-img').addClass('d-none');
        card.find('.board-person-color-img').removeClass('d-none');
    }

    /**
     * Restores the monochrome image state for the provided card element.
     *
     * @param {JQuery} card - Card container whose imagery should be toggled back to black-and-white.
     */
    function showBlack(card) {
        card.find('.board-person-color-img').addClass('d-none');
        card.find('.board-person-black-img').removeClass('d-none');
    }

    if ($('#boardofdirectors').length) {
        // Desktop Hover Effect
        $('.board-person-black-img').on('mouseover', function () {
            let card = $(this).closest('.board-cards');
            showColor(card);
        });

        $('.board-person-color-img').on('mouseout', function () {
            let card = $(this).closest('.board-cards');
            showBlack(card);
        });

        // Mobile: Only one stays active
        $('.board-cards').on('touchstart', function () {
            // Turn all cards to black first
            $('.board-cards').each(function () {
                showBlack($(this));
            });

            // Then show color only for the tapped card
            showColor($(this));
        });
    }
});
